function _pipe(f, g) {
  return function () {
    return g.call(this, f.apply(this, arguments));
  };
}
module.exports = _pipe;


//////////////////
// WEBPACK FOOTER
// ../~/ramda/src/internal/_pipe.js
// module id = 686
// module chunks = 0